<template>
    <div class="svg-container">
        <svg class="icon mas-icon" :class="['mas-' + icon, iconClass]">
            <use :xlink:href="'#' + icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
        </svg>
    </div>
</template>

<script>

    /** This functions removes the fill attribute from all nested children so it can be adjusted using css. */
    function removeFillRecursively(el) {
        if (!el) {
            return;
        }
        el.removeAttribute('fill');

        [].forEach.call(el.children, child => {
            removeFillRecursively(child);
        });
    }

    export default {
        name: "SvgIcon",
        props: {
            icon: {
                type: String,
                required: true,
            },
            removeInlineFill: {
                type: Boolean,
                default: true
            },
            isOutlined: {
                type: Boolean,
                default: false
            },
            growByHeight: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            iconClass() {
                return {
                    'is-outlined': this.isOutlined,
                }
            }
        },
        methods: {
            adjustProperties() {
                const svgElement = this.$el.firstElementChild;
                const sprite = document.querySelector(`#${this.icon}`);

                const viewBox = sprite.getAttribute('viewBox').split(' ').map(n => Number(n));
                const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2);

                if (this.removeInlineFill) {
                    removeFillRecursively(svgElement);
                }

                /** set width and height relative to font size
                 if growByHeight is true, height set to 1em else width set to 1em and remaining is calculated based on widthToHeight ratio */

                if (this.growByHeight) {
                    svgElement.setAttribute('height', '1em');
                    svgElement.setAttribute('width', `${widthToHeight}em`);
                } else {
                    svgElement.setAttribute('width', '1em');
                    svgElement.setAttribute('height', `${1 / widthToHeight}em`);
                }
            }
        },
        mounted() {
            if (this.$el.firstElementChild.nodeName === 'svg') {
                this.adjustProperties();
            }
        },
        updated() {
            this.adjustProperties();
        }
    }
</script>

<style lang="scss">
    .svg-container {
        display: inline-flex;
        justify-content: center;
    }

    .button .icon {
        margin: 0;
    }

    svg.icon.mas-icon {
        width: auto;
        height: auto;
        vertical-align: middle;
    }
</style>
